// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#eb5757","bgColor":"white","header":"f_g","row":"f_r","icons":"f_s","text":"f_t"};